export default "__VITE_ASSET__b388beb9__"